exports.onClientEntry = () => {
  const pathPrefix =
    typeof __PATH_PREFIX__ !== "undefined" ? __PATH_PREFIX__ : "";

  // Gatsby normalizes the prefixed root page from "/prefix" to "/prefix/".
  // These LPs are intentionally served without the final slash.
  if (window.pagePath === "/" && window.location.pathname === pathPrefix) {
    window.pagePath = "";
  }
};
